import tools from "../../../../../helpers/tools";
import { initiales } from "../../droitsCommentaire";
import "../../commentList.scss";

const FORMAT_DATE = "dd/MM/yyyy 'à' HH:mm";

// En-tête d'un commentaire : avatar aux initiales, auteur, date, et la mention
// « modifié » si demandée. Sert aussi aux aperçus des cartes.
export const CommentCreatedBy = ({ comment, avecModification = false }) => (
  <div className="cl-tete">
    <span className="cl-avatar" aria-hidden="true">
      {initiales(comment.createdBy)}
    </span>
    <b className="cl-auteur">{comment.createdBy}</b>
    <span className="cl-date">{tools.formatDate(comment.createdAt, FORMAT_DATE)}</span>
    {avecModification && <CommentUpdateddBy comment={comment} />}
  </div>
);

// Mention « modifié », avec l'auteur et la date de la modification en infobulle.
export const CommentUpdateddBy = ({ comment }) =>
  comment.updatedBy ? (
    <span className="cl-modifie" title={`Modifié par ${comment.updatedBy} le ${tools.formatDate(comment.updatedAt, FORMAT_DATE)}`}>
      modifié
    </span>
  ) : null;
